import * as React from 'react';
import { TooltipStyles } from './Style'
import { useContext } from 'react';
import { PerformAssessmentContext } from './PerformAssessmentContext';
import { AnimatePresence } from "motion/react"
import { Img, SmallSpace } from 'styles/GlobalStyle';
import { Six as GoAvatar } from 'assets'
import { useState } from 'react';
import * as motion from "motion/react-client"
import { IconButton } from '@mui/material';

const TooltipMessage = (props) => {
    const { handleCartoonSpeaking, cartoonSpeaking, tooltip, tooltipOpen, handleTooltip } = props
    const { isHighGrade } = useContext(PerformAssessmentContext)
    const [shouldAnimate, setShouldAnimate] = useState(false);

    return (
        !tooltip ||
        <TooltipStyles isHighGrade={isHighGrade}>
            {!shouldAnimate ? (
                <motion.div
                    exit={{ opacity: 0 }}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.7 }}
                    key="box"
                >
                    {isHighGrade ?
                        <div className='avatat-and-tooltip'>
                            <div className='avatar'>
                                <Img src={GoAvatar} />
                            </div>
                            <div className='tooltip-content'>
                                {tooltip}
                                {/* <div className='on-off-icon'>
                                        <IconButton onClick={handleCartoonSpeaking}>
                                            {cartoonSpeaking ?
                                                <i class="fa-light fa-volume-xmark" /> :
                                                <i class="fa-light fa-volume-high" />}
                                        </IconButton>
                                    </div> */}
                            </div>
                        </div> :
                        <div className='tooltip-content'>
                            {tooltip}
                        </div>
                    }
                </motion.div>) : null}
        </TooltipStyles>

    )
}

export default TooltipMessage